import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';
import { StorageType } from '@app/origami-api/constants/storage-type';
import { Locale } from '@app/origami-api/constants';
import { IndexingEngine } from '@app/origami-api/constants/indexing-engine';
import { SearchEngine } from '@app/origami-api/constants/search-engine';

// todo update with %SupportEmail% and other

export namespace GeneralFields {
  export enum IrbIntegrationField {
    ProtocolIdPrefix = 'General.ProtocolIdPrefix',
  }

  export enum TaskField {
    SiteFollowUpDate = 'Task.SiteFollowUpDate',
    EnableViewByTagForTasks = 'Task.EnableViewByTagForTasks',
  }

  export enum KeywordLookupField {
    CheckboxGroupLimit = 'KeywordLookup.CheckboxGroupLimit',
    RadioGroupLimit = 'KeywordLookup.RadioGroupLimit',
    CheckboxComboLimit = 'KeywordLookup.CheckboxComboLimit',
    RadioComboLimit = 'KeywordLookup.RadioComboLimit',
  }

  export enum RecNavField {
    RecordsRerPage = 'RecNav.RecordsRerPage',
    MaxNumUnreadDocs = 'RecNav.MaxNumUnreadDocs',
    DaysToShowNewUsers = 'RecNav.DaysToShowNewUsers',
    MaxRecentISNumber = 'RecNav.MaxRecentISNumber',
    MaxRecentCommLogsNumber = 'RecNav.MaxRecentCommLogsNumber',
    MaxRecentTasksNumber = 'RecNav.MaxRecentTasksNumber',
  }

  export enum WelcomeScreenField {
    HTML = 'WelcomeScreen.HTML',
  }

  export enum AccessToAnyRoomField {
    AccessToAnyRoom = 'Home.AccessToAnyRoom',
  }

  export enum ModuleField {
    EnableQA = 'Module.EnableQA',
    EnableWorkflow = 'Module.EnableWorkflow',
    EnableIzendaReport = 'Module.EnableIzendaReport',
    EnableETMF = 'Module.EnableETMF',
    EnableEISF = 'Module.EnableEISF',
    SiteStartPage = 'Module.SiteStartPage',
    EnableSSU = 'Module.EnableSSU',
    EnableQMS = 'Module.EnableQMS',
    EnableAmendments = 'Module.EnableAmendments',
    EnableTasks = 'Module.EnableTasks',
    EnableTranslationRequest = 'Module.EnableTranslationRequest',
    EnableSitePortal = 'Module.EnableSitePortal',
    EnableAudit = 'Module.EnableAudit',
    EnableEventManagement = 'Module.EnableEventManagement',
    EnableEmail = 'Module.EnableEmail',
    EnableQueryResolution = 'Module.EnableQueryResolution',
    DefaultContext = 'Module.DefaultContext',
    DefaultModule = 'Module.DefaultModule',
    Acknowledgment = 'Module.Acknowledgment',
    EnableOrganization = 'Module.EnableOrganization',
  }

  export enum IndexOutlineField {
    ShowEmptyFolders = 'IndexOutline.ShowEmptyFolders',
    ShowEmptyFoldersByDefault = 'IndexOutline.ShowEmptyFoldersByDefault',
    UseAutoPrefix = 'IndexOutline.UseAutoPrefix',
    PrefixType = 'IndexOutline.PrefixType',
    ShowDocumentsCount = 'IndexOutline.ShowDocumentsCount',
    UploadFolderName = 'IndexOutline.UploadFolderName',
    InboxFolderName = 'IndexOutline.InboxFolderName',
    EFaxFolderName = 'IndexOutline.EFaxFolderName',
    IrbUploadFolderName = 'IndexOutline.IrbUploadFolderName',
    DefaultIndexPosition = 'IndexOutline.DefaultIndexPosition',
    EnableCustomIndexName = 'IndexOutline.EnableCustomIndexName',
    CustomIndexName = 'IndexOutline.CustomIndexName',
    AutoDetectIndexPosition = 'IndexOutline.AutoDetectIndexPosition',
    AllowFilesDropOnIndex = 'IndexOutline.AllowFilesDropOnIndex',
    RejectedIndexPosition = 'IndexOutline.RejectedIndexPosition',
  }

  export enum GeneralField {
    CurrentStudyEventTypeId = 'General.CurrentStudyEventTypeId',
    TimeZone = 'General.TimeZone',
    MapsProvider = 'General.MapsProvider',
    DataRoomCountries = 'General.DataRoomCountries',
    DefaultLocale = 'General.DefaultLocale',
    DateFormat = 'General.DateFormat',
    StudyContactNumber = 'General.StudyContactNumber',
    StudyContactNumberHelpText = 'General.StudyContactNumberHelpText',
    RecentlyVisitedStudies = 'General.RecentlyVisitedStudies',
    ExternalServicesConfig = 'General.ExternalServicesConfig',
    EnableMaintenanceBanner = 'General.EnableMaintenanceBanner',
    MaintenanceBanner = 'General.MaintenanceBanner',
    MuteMaintenanceBanner = 'General.MuteMaintenanceBanner',
    KpiCardsHeatmapSettings = 'General.KpiCardsHeatmapSettings',
    SsuKpiCardsHeatmapSettings = 'General.SsuKpiCardsHeatmapSettings',
    BuildVersionReplaceFrom = 'General.BuildVersionReplaceFrom',
    BuildVersionReplaceTo = 'General.BuildVersionReplaceTo',
  }

  export enum RegistrationField {
    ConfirmationPage = 'RegistrationConfirmation.HTML',
    AlreadyRegisteredPage = 'Registration.AlreadyRegisteredPage',
  }

  export enum ExportSettingField {
    DocumentMetadataFields = 'Export.DocumentMetadataFields',
    MetaDataFields = 'Export.MetaDataFields',
    AccountExpirationTime = 'Export.TemporaryFTPAccountExpirationTime',
    ExportArchiveSizeLimit = 'Export.DocumentArchiveSizeLimit',
    TaskMetadataFields = 'Export.TaskMetadataFields',
    RoomMetadataFields = 'Export.RoomMetadataFields',
  }

  export enum DocumentField {
    ShowOnlyFinalAsCollected = 'Document.ShowOnlyFinalAsCollected',
    FilterCompletenessBySiteStatus = 'Document.FilterCompletenessBySiteStatus',
    AutoPurgeDaysNo = 'Document.AutoPurgeDaysNo',
    EnableAutoPurge = 'Document.EnableAutoPurge',
    EnablePrint = 'Document.EnablePrint',
    EnableEmail = 'Document.EnableEmail',
    EnableEmailAttachment = 'Document.EnableEmailAttachment',
    EnableExport = 'Document.EnableExport',
    EnableOptimization = 'Document.enableOptimization',
    EnableOcr = 'Document.enableOCR',
    EnableNonPDFToPDF = 'Document.EnableNonPDFToPDF',
    SplitMsgFile = 'Document.SplitMsgFile',
    EnablePDFForFlexPaperOnly = 'Document.EnablePDFForFlexPaperOnly',
    EnableAutomaticNonPDFToPDF = 'Document.EnableAutomaticNonPDFToPDF',
    ConversionFileTypes = 'Document.FileTypesToBeConverted',
    PDFfix = 'Document.PDFfix',
    ExpireNotificationPeriod = 'Document.ExpireNotificationPeriod',
    DocumentDuplicateCriteria = 'Document.DuplicateCriteria',
    CheckDuplicateByDocumentName = 'Document.CheckDuplicateByDocumentName',
    CheckDuplicateByTitleDate = 'Document.CheckDuplicateByTitleDate',
    ExpirationSubscribedUsers = 'Document.ExpirationSubscribedUsers',
    ExpirationSubscribedGroups = 'Document.ExpirationSubscribedGroups',
    ExtensionsToDowngrade = 'Document.ExtensionsToDowngrade',
    ExpirationDashboardPeriod = 'Document.ExpirationDashboardPeriod',
    ExpirationDashboardShowOptions = 'Document.ExpirationDashboardShowOptions',
    ExpirationDashboardAvailableMethods = 'Document.ExpirationDashboardAvailableMethods',
    DataRoomArchiveMaxPathLength = 'Document.DataRoomArchiveMaxPathLength',
    DataRoomArchiveMaxFileNameLength = 'Document.DataRoomArchiveMaxFileNameLength',
    EnableUseDocUploadDate = 'Document.UseDocUploadDate',
    EnableAutoNameGeneration = 'Document.EnableAutoNameGeneration',
    EnableAutoroutingOfDocuments = 'Document.EnableAutoroutingOfDocuments',
    UseDocumentNameFieldAsOutputName = 'Document.UseDocumentNameFieldAsOutputFileName',
    UseSeparatorSheetForPrint = 'Document.UseSeparatorSheetForPrint',
    IncludeTicksInFileName = 'Document.IncludeTicksInFileName',
    EnableViewByDocumentType = 'Document.EnableViewByDocumentType',
    EnableMassImportForEditors = 'Document.EnableMassImportForEditors',
    ShowNonFinalDocsByDefault = 'Document.ShowNonFinalDocsByDefault',
    EnableSystemFoldersExport = 'Document.EnableSystemFoldersExport',
    UseDocTitleForDocsExport = 'Document.UseDocTitleAsFileNameForDocsExport',
    UseLogicalFieldsOrderForDocsExport = 'Document.UseLogicalFieldsOrderForDocsExport',
    EnableDocumentProfileWithoutAttachment = 'Document.EnableDocumentProfileWithoutAttachment',
    MaxDocumentsToMerge = 'Document.MaxDocumentsToMerge',
    DefaultStartingVersion = 'Document.DefaultStartingVersion',
    RecognitionLanguages = 'Document.RecognitionLanguages',
    TypicalRecognitionLanguages = 'Document.TypicalRecognitionLanguages',
    OcrSubmissionMode = 'Document.OCRSubmissionMode',
    FileStorageType = 'Document.FileStorageType',
    EnableScheduledExport = 'Document.EnableScheduledExport',
    ScheduledExportFrequency = 'Document.ScheduledExportFrequency',
    ScheduledExportPeriod = 'Document.ScheduledExportPeriod',
    ScheduledExportRoomTopicIds = 'Document.ScheduledExportRoomTopicIds',
    ScheduledExportCategoryTopicIds = 'Document.ScheduledExportCategoryTopicIds',
    ScheduledExportEmailRecipients = 'Document.ScheduledExportEmailRecipients',
    EtmfReadyDocumentsPublishing = 'Document.EtmfReadyDocumentsPublishing',
    EnablePublishToEtmf = 'Document.EnablePublishToEtmf',
    EnablePageCount = 'Document.EnablePageCounting',
    UploadDocumentsAsFinal = 'CTMSIntegration.UploadDocumentsAsFinal',
    DontAllowUsersToEditSiteContacts = 'CTMSIntegration.DontAllowUsersToEditSiteContacts',
    GeneralDocumentsUpload = 'GeneralDocumentsUpload.UploadDocumentsAsFinal',
    ReplacingReasons = 'Document.ReplacingReasons',
    EnableViewByTagForDocuments = 'Document.EnableViewByTagForDocuments',
    NDDTemplateRoomId = 'General.NDDTemplateRoomId',
    ShowNonRequired = 'Document.ShowNonRequired',
    FindDuplicatesByHash = 'Document.FindDuplicatesByHash',
    DocumentDistributionMode = 'Document.DocumentDistributionMode',
    EnableSiteFoldersTreeForUploadDashlet = 'Document.EnableSiteFoldersTreeForUploadDashlet',
    EnableCertification = 'Document.EnableCertification',
    CertifiedCopyReason = 'Document.CertifiedCopyReason',
    EnableCausalityTracking = 'Document.EnableCasualtyTracking',
    DoNotForceSafetyLetterFullScrolling = 'Document.DoNotForceSafetyLetterFullScrolling',
    DisableOfflineCheckOut = 'Document.DisableOfflineCheckOut',
    QueryManagerAllowResolve = 'Document.QueryManagerAllowResolve',
    QueryManagerAllowRespond = 'Document.QueryManagerAllowRespond',
    AddAssigneesToQuery = 'Document.AddAssigneesToQuery',
    EnableMetadataExtraction = 'Document.EnableMetadataExtraction',
    EnableMetadataExtractionDomain = 'Document.EnableMetadataExtractionDomain',
    ConfidenceScoreDocType = 'Document.ConfidenceScoreDocType',
    ConfidenceScoreInvSite = 'Document.ConfidenceScoreInvSite',
    ConfidenceScoreContact = 'Document.ConfidenceScoreContact',
    ConfidenceScoreCountry = 'Document.ConfidenceScoreCountry',
    ConfidenceScoreDocumentDate = 'Document.ConfidenceScoreDocumentDate',
    ConfidenceScoreAdditionalFields = 'Document.ConfidenceScoreAdditionalFields',
    ConfidenceScoreMedium = 'Document.ConfidenceScoreMedium',
    ConfidenceScoreHigh = 'Document.ConfidenceScoreHigh',
    RiskFactorDocTypeEnabling = 'Document.RiskFactors.EnableDocumentType',
    EnableModifiers = 'Document.RiskFactors.EnableModifiers',
    RiskLevelHigh = 'Document.RiskLevel.High',
    RiskLevelMedium = 'Document.RiskLevel.Medium',
    RiskLevelScoreDisplay = 'Document.RiskLevel.ScoreDisplay',
    DoNotAllowEditorsToDeleteDocuments = 'Document.DoNotAllowEditorsToDeleteDocuments',
    DefaultViewMode = 'Document.DefaultViewMode',
  }

  export enum SiteField {
    EnableSiteRisk = 'Site.RiskFactors.EnableSiteRisk',
    EnableMissing = 'Site.RiskFactors.EnableMissing',
    EnableTimeliness = 'Site.RiskFactors.EnableTimeliness',
    EnableQuality = 'Site.RiskFactors.EnableQuality',

    RiskLevelHigh = 'Site.RiskLevel.High',
    RiskLevelMedium = 'Site.RiskLevel.Medium',
    RiskLevelScoreDisplay = 'Site.RiskLevel.ScoreDisplay',

    MissingScorePrevalence = 'Site.RiskFactors.MissingScorePrevalence',
    MissingScoreMedium = 'Site.RiskFactors.MissingScoreMedium',
    MissingScoreLow = 'Site.RiskFactors.MissingScoreLow',

    TimelinessScorePrevalence = 'Site.RiskFactors.TimelinessScorePrevalence',
    TimelinessScoreMedium = 'Site.RiskFactors.TimelinessScoreMedium',
    TimelinessScoreLow = 'Site.RiskFactors.TimelinessScoreLow',

    QualityScorePrevalence = 'Site.RiskFactors.QualityScorePrevalence',
    QualityScoreMedium = 'Site.RiskFactors.QualityScoreMedium',
    QualityScoreLow = 'Site.RiskFactors.QualityScoreLow',
  }

  export enum InboxField {
    EnableInbox = 'Inbox.EnableInbox',
    EnableSsuInbox = 'Inbox.EnableSsuInbox',
    EnableCommunicationInbox = 'Inbox.EnableCommunicationInbox',
    AcceptEmailFrom = 'Inbox.AcceptEmailFrom',
    DomainNameWhiteList = 'Inbox.DomainNameWhiteList',
    DomainAddress = 'Inbox.DomainAddress',
    InboxEmail = 'Inbox.Email',
    SsuInboxEmail = 'Inbox.SsuEmail',
    CommunicationEmail = 'Inbox.CommunicationEmail',
    QueryResolutionInboxEmail = 'Inbox.QueryResolutionEmail',
    DocumentsAsFinal = 'Inbox.DocumentsAsFinal',
    CodingNotRequired = 'Inbox.CodingNotRequired',
  }

  export enum OutboxField {
    EnableCommunicationOutbox = 'Outbox.EnableCommunicationOutbox',
  }

  export enum BrandingField {
    ApplicationName = 'Branding.ApplicationName',
    SupportEmail = 'Branding.SupportEmail',
    Logo = 'Branding.Logo',
  }

  export enum DtsIndexField {
    DtsFileTypes = 'DtsIndex.FileTypes',
    TAIndexLimit = 'General.TAIndexLimit',
    SearchEngine = 'Search.SearchEngine',
    IndexingEngine = 'Search.IndexingEngine',
    SyncStatus = 'Sync.SyncStatus',
    UpdatedDate = 'Sync.UpdatedDate',
  }

  export enum eFaxField {
    EnableEFax = 'eFax.EnableEFax',
    BarcodeInstructions = 'eFax.BarcodeInstructions',
  }

  export enum DocumentViewerField {
    FlashViewerMode = 'Viewer.FlashViewerMode',
  }

  export enum SimplifiedUiField {
    Instructions = 'SimplifiedUI.Instructions',
  }

  export enum LinkedServersField {
    ServerUrls = 'LinkedServersConfig.ServerUrls',
  }

  export enum TranslationField {
    EnableMachineTranslation = 'Translation.EnableMachineTranslation',
    AllowedTranslationLanguages = 'Translation.AllowedTranslationLanguages',
    DefaultTranslateFromLanguage = 'Translation.DefaultTranslateFromLanguage',
    DefaultTranslateToLanguage = 'Translation.DefaultTranslateToLanguage',
  }

  export enum RoomManagementField {
    ClosedFolder = 'General.ClosedFolder',
  }

  export enum EventConfigField {
    ReminderDays = 'Event.ReminderDays',
    DefaultReminderRecipientUsers = 'Event.DefaultReminderRecipientUsers',
    DefaultReminderRecipientGroups = 'Event.DefaultReminderRecipientGroups',
    ReminderForOverdue = 'Event.ReminderForOverdue',
    ReminderForCompleted = 'Event.ReminderForCompleted',
    SuggestPlaceholders = 'Document.SuggestPlaceholders',
    MatchPlaceholdersAutomatically = 'Document.MatchPlaceholdersAutomatically',
  }

  export enum Search {
    FacetValuesLimit = 'Search.FacetValuesLimit',
  }
}

class IrbIntegrationConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.IrbIntegrationField.ProtocolIdPrefix, '')
  protocolIdPrefix: SettingValue<string>;
}

class TaskConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.TaskField.SiteFollowUpDate, 2) siteFollowUpDate: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.TaskField.EnableViewByTagForTasks, false)
  enableViewByTagForTasks: SettingValue<boolean>;
}

class KeywordLookup extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.KeywordLookupField.CheckboxGroupLimit, 5)
  checkboxGroupLimit: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.KeywordLookupField.RadioGroupLimit, 5) radioGroupLimit: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.KeywordLookupField.CheckboxComboLimit, 20)
  checkboxComboLimit: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.KeywordLookupField.RadioComboLimit, 0) radioComboLimit: SettingValue<number>;
}

class RecNavConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.RecNavField.RecordsRerPage, 20) recordsRerPage: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.RecNavField.MaxNumUnreadDocs, 10) maxNumUnreadDocs: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.RecNavField.DaysToShowNewUsers, 10) daysToShowNewUsers: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.RecNavField.MaxRecentISNumber, 20) maxRecentISNumber: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.RecNavField.MaxRecentCommLogsNumber, 20)
  maxRecentCommLogsNumber: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.RecNavField.MaxRecentTasksNumber, 20)
  maxRecentTasksNumber: SettingValue<number>;
}

class WelcomeScreenConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.WelcomeScreenField.HTML, '<h4>Welcome, ##UserName##.</h4>')
  html: SettingValue<string>;
}

class AccessToAnyRoomConfig extends SettingsSubModule {
  @SettingsSubModule.value(
    GeneralFields.AccessToAnyRoomField.AccessToAnyRoom,
    "<h4>##UserName## doesn't have access to any rooms.</h4>",
  )
  accessToAnyRoom: SettingValue<string>;
}

class ModuleConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableQA, false) enableQA: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableWorkflow, false) enableWorkflow: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableIzendaReport, false)
  enableIzendaReport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableETMF, false) enableETMF: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableEISF, false) enableEISF: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.SiteStartPage, '') siteStartPage: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableSSU, false) enableSSU: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableQMS, false) enableQMS: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableAmendments, false) enableAmendments: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableTasks, false) enableTasks: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableTranslationRequest, false)
  enableTranslationRequest: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableSitePortal, false) enableSitePortal: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableAudit, false) enableAudit: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableEventManagement, false)
  enableEventManagement: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableEmail, false) enableEmail: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableQueryResolution, false)
  enableQueryResolution: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.DefaultContext, '') defaultContext: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ModuleField.DefaultModule, '') defaultModule: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ModuleField.Acknowledgment, false) acknowledgment: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.ModuleField.EnableOrganization, false) organization: SettingValue<boolean>;
}

class IndexOutlineConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.ShowEmptyFolders, false)
  showEmptyFolders: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.ShowEmptyFoldersByDefault, false)
  showEmptyFoldersByDefault: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.UseAutoPrefix, false) useAutoPrefix: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.PrefixType, 0) prefixType: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.ShowDocumentsCount, false)
  showDocumentsCount: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.UploadFolderName, '*Upload')
  uploadFolderName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.InboxFolderName, '*Inbox')
  inboxFolderName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.EFaxFolderName, '*eFax')
  eFaxFolderName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.IrbUploadFolderName, '*IRBUploads')
  irbUploadFolderName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.DefaultIndexPosition, '')
  defaultIndexPosition: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.EnableCustomIndexName, false)
  enableCustomIndexName: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.CustomIndexName, 'Index')
  customIndexName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.AutoDetectIndexPosition, false)
  autoDetectIndexPosition: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.AllowFilesDropOnIndex, false)
  alwaysAllowSelectFolder: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.IndexOutlineField.RejectedIndexPosition, 0)
  rejectedIndexPosition: SettingValue<number>;
}

interface ExternalLink {
  name: string;
  url: string;
  enabled: boolean;
}

export interface KpiCardsHeatmap {
  metrics?: {
    name: string;
    data: {
      green: {
        min: number;
        max: number;
      };
      yellow: {
        min: number;
        max: number;
      };
      red: {
        min: number;
        max: number;
      };
    };
  }[];
}

class GeneralConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.GeneralField.CurrentStudyEventTypeId, '')
  currentStudyEventTypeId: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.TimeZone, '') timeZone: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.MapsProvider, '') mapsProvider: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.DataRoomCountries, '') dataRoomCountries: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.DateFormat, '') dateFormat: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.DefaultLocale, '') defaultLocale: SettingValue<Locale>;
  @SettingsSubModule.value(GeneralFields.GeneralField.StudyContactNumber, '') studyContactNumber: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.StudyContactNumberHelpText, '')
  studyContactNumberHelpText: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.RecentlyVisitedStudies, '')
  recentlyVisitedStudies: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.ExternalServicesConfig, '', {
    setterConverter(value: ExternalLink[]): string {
      return JSON.stringify(value);
    },
    getterConverter(value: string): ExternalLink[] {
      try {
        return JSON.parse(value);
      } catch (ex) {}

      return [];
    },
  })
  externalServicesConfig: SettingValue<ExternalLink[]>;
  @SettingsSubModule.value(GeneralFields.GeneralField.EnableMaintenanceBanner, false)
  enableMaintenanceBanner: SettingValue<boolean>;
  @SettingsSubModule.value(
    GeneralFields.GeneralField.MaintenanceBanner,
    '<h4>Planned System Maintenance</h4>Date: Saturday, 19th January 2013<br>Start Time: 5:00 AM UTC (12:00 AM ET / 6:00 AM CET)<br>Approximate End: 5:45 AM UTC<br>The scheduled downtime is expected to be around 45 minutes.',
  )
  maintenanceBanner: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.KpiCardsHeatmapSettings, '', {
    setterConverter(value: KpiCardsHeatmap[]): string {
      return JSON.stringify(value);
    },
    getterConverter(value: string): KpiCardsHeatmap {
      try {
        return JSON.parse(value);
      } catch (ex) {}

      return {};
    },
  })
  kpiCardsHeatmapSettings: SettingValue<KpiCardsHeatmap>;
  @SettingsSubModule.value(GeneralFields.GeneralField.SsuKpiCardsHeatmapSettings, '', {
    setterConverter(value: KpiCardsHeatmap[]): string {
      return JSON.stringify(value);
    },
    getterConverter(value: string): KpiCardsHeatmap {
      try {
        return JSON.parse(value);
      } catch (ex) {}

      return {};
    },
  })
  ssuKpiCardsHeatmapSettings: SettingValue<KpiCardsHeatmap>;
  @SettingsSubModule.value(GeneralFields.GeneralField.BuildVersionReplaceFrom, '')
  buildVersionReplaceFrom: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.GeneralField.BuildVersionReplaceTo, '')
  buildVersionReplaceTo: SettingValue<string>;
}

class Registration extends SettingsSubModule {
  @SettingsSubModule.value(
    GeneralFields.RegistrationField.ConfirmationPage,
    '<b>Congratulations! You have successfully registered.</b><br><br>' +
      'You can sign in to %CompanyName% by using your email address "##Email##" as the username and the password you just registered.<br><br>' +
      'If you have any questions about getting started please contact us at <a href="mailto:%SupportEmail%">%SupportEmail%</a>.<br><br>' +
      'Please go to <a href="##SiteHome##">##SiteHome##</a> to sign in to %CompanyName%.',
  )
  confirmationPage: SettingValue<string>;
  @SettingsSubModule.value(
    GeneralFields.RegistrationField.AlreadyRegisteredPage,
    'This registration link has already been used for registration in the system.<br/>' +
      'Please, contact our <a href="mailto:%SupportEmail%">helpdesk</a>.<br/>' +
      '<a href="##SiteHome##">Home</a>.',
  )
  alreadyRegisteredPage: SettingValue<string>;
}

class ExportSetting extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.ExportSettingField.DocumentMetadataFields, '')
  documentMetadataFields: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ExportSettingField.MetaDataFields, '') metaDataFields: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ExportSettingField.AccountExpirationTime, 1)
  accountExpirationTime: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.ExportSettingField.ExportArchiveSizeLimit, 0)
  maxDocumentsSizeMbPerPackage: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.ExportSettingField.TaskMetadataFields, '')
  taskMetadataFields: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.ExportSettingField.RoomMetadataFields, '')
  roomMetadataFields: SettingValue<string>;
}

class DocumentConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.DocumentField.ShowOnlyFinalAsCollected, false)
  showOnlyFinalAsCollected: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.FilterCompletenessBySiteStatus, false)
  filterCompletenessBySiteStatus: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.AutoPurgeDaysNo, 10) autoPurgeDaysNo: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableAutoPurge, false) enableAutoPurge: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnablePrint, false) enablePrint: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableEmail, false) enableEmail: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableEmailAttachment, false)
  enableEmailAttachment: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableExport, false) enableExport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableOptimization, false)
  enableOptimization: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableOcr, false) enableOcr: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableNonPDFToPDF, false)
  enableNonPDFToPDF: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.SplitMsgFile, false) splitMsgFile: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnablePDFForFlexPaperOnly, false)
  enablePDFForFlexPaperOnly: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableAutomaticNonPDFToPDF, true)
  enableAutomaticNonPDFToPDF: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConversionFileTypes, '', {
    setterConverter: (value: string[]): string => value.join(),
    getterConverter: (value: string): string[] => (value || '').trim().toLowerCase().split(','),
  })
  conversionFileTypes: SettingValue<string[]>;
  @SettingsSubModule.value(GeneralFields.DocumentField.PDFfix, 0) pDFfix: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpireNotificationPeriod, 10)
  expireNotificationPeriod: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DocumentDuplicateCriteria, 0)
  documentDuplicateCriteria: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.CheckDuplicateByDocumentName, false)
  checkDuplicateByDocumentName: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.CheckDuplicateByTitleDate, false)
  checkDuplicateByTitleDate: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpirationSubscribedUsers, '')
  expirationSubscribedUsers: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpirationSubscribedGroups, '')
  expirationSubscribedGroups: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExtensionsToDowngrade, '')
  extensionsToDowngrade: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpirationDashboardPeriod, 10)
  expirationDashboardPeriod: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpirationDashboardShowOptions, true)
  expirationDashboardShowOptions: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ExpirationDashboardAvailableMethods, '1,2,3')
  expirationDashboardAvailableMethods: SettingValue<string>; // showing all methods by default
  @SettingsSubModule.value(GeneralFields.DocumentField.DataRoomArchiveMaxPathLength, 250)
  dataRoomArchiveMaxPathLength: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DataRoomArchiveMaxFileNameLength, 65)
  dataRoomArchiveMaxFileNameLength: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableUseDocUploadDate, false)
  enableUseDocUploadDate: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableAutoNameGeneration, false)
  enableAutoNameGeneration: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableAutoroutingOfDocuments, false)
  enableAutoroutingOfDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.UseDocumentNameFieldAsOutputName, false)
  useDocumentNameFieldAsOutputName: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.UseSeparatorSheetForPrint, false)
  useSeparatorSheetForPrint: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.IncludeTicksInFileName, false)
  includeTicksInFileName: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableViewByDocumentType, false)
  enableViewByDocumentType: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableMassImportForEditors, false)
  enableMassImportForEditors: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ShowNonFinalDocsByDefault, false)
  showNonFinalDocsByDefault: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableSystemFoldersExport, false)
  enableSystemFoldersExport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.UseDocTitleForDocsExport, false)
  useDocTitleForDocsExport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.UseLogicalFieldsOrderForDocsExport, false)
  useLogicalFieldsOrderForDocsExport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableDocumentProfileWithoutAttachment, false)
  enableDocumentProfileWithoutAttachment: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.MaxDocumentsToMerge, 10)
  maxDocumentsToMerge: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DefaultStartingVersion, 1)
  defaultStartingVersion: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.RecognitionLanguages, 'English')
  recognitionLanguages: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.TypicalRecognitionLanguages, '')
  typicalRecognitionLanguages: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.OcrSubmissionMode, 'Manual')
  ocrSubmissionMode: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.FileStorageType, StorageType.Cifs)
  fileStorageType: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableScheduledExport, false)
  enableScheduledExport: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ScheduledExportFrequency, 0)
  scheduledExportFrequency: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ScheduledExportPeriod, '')
  scheduledExportPeriod: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ScheduledExportRoomTopicIds, '')
  scheduledExportRoomTopicIds: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ScheduledExportCategoryTopicIds, '')
  scheduledExportCategoryTopicIds: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ScheduledExportEmailRecipients, '')
  scheduledExportEmailRecipients: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EtmfReadyDocumentsPublishing, 0)
  etmfReadyDocumentsPublishing: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnablePublishToEtmf, false)
  enablePublishToEtmf: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnablePageCount, false) enablePageCount: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.UploadDocumentsAsFinal, false)
  uploadDocumentsAsFinal: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DontAllowUsersToEditSiteContacts, false)
  dontAllowUsersToEditSiteContacts: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.GeneralDocumentsUpload, false)
  generalDocumentsUpload: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableViewByTagForDocuments, false)
  enableViewByTagForDocuments: SettingValue<boolean>;
  //@SettingsSubModule.value(GeneralFields.DocumentField.ReplacingReasons, '') replacingReasons: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ReplacingReasons, '', {
    setterConverter: (value: string[]): string => value.map((item) => btoa(item)).join(),
    getterConverter: (value: string): string[] =>
      (value || '')
        .trim()
        .split(',')
        .map((item) => atob(item)),
  })
  replacingReasons: SettingValue<string[]>;
  @SettingsSubModule.value(GeneralFields.DocumentField.NDDTemplateRoomId, 0) nDDTemplateRoomId: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ShowNonRequired, false) showNonRequired: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.FindDuplicatesByHash, true)
  findDuplicatesByHash: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DocumentDistributionMode, 0)
  documentDistributionMode: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableSiteFoldersTreeForUploadDashlet, false)
  enableSiteFoldersTreeForUploadDashlet: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableCertification, false)
  enableCertification: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.CertifiedCopyReason, '')
  certifiedCopyReason: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableCausalityTracking, false)
  enableCausalityTracking: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DoNotForceSafetyLetterFullScrolling, false)
  doNotForceSafetyLetterFullScrolling: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DisableOfflineCheckOut, false)
  disableOfflineCheckOut: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.QueryManagerAllowResolve, true)
  queryManagerAllowResolve: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.QueryManagerAllowRespond, false)
  queryManagerAllowRespond: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.AddAssigneesToQuery, false)
  addAssigneesToQuery: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableMetadataExtraction, false)
  enableMetadataExtraction: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableMetadataExtractionDomain, false)
  enableMetadataExtractionDomain: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreDocType, 20)
  confidenceScoreDocType: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreInvSite, 20)
  confidenceScoreInvSite: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreContact, 10)
  confidenceScoreContact: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreCountry, 10)
  confidenceScoreCountry: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreDocumentDate, 10)
  confidenceScoreDocumentDate: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreAdditionalFields, 30)
  confidenceScoreAdditionalFields: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreMedium, 40)
  confidenceScoreMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.ConfidenceScoreHigh, 70)
  confidenceScoreHigh: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.RiskFactorDocTypeEnabling, true)
  riskFactorDocTypeEnabling: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.EnableModifiers, false)
  enableModifiers: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.DocumentField.RiskLevelHigh, 80)
  riskLevelHigh: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.RiskLevelMedium, 40)
  riskLevelMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.RiskLevelScoreDisplay, 1)
  riskLevelScoreDisplay: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DoNotAllowEditorsToDeleteDocuments, 0)
  doNotAllowEditorsToDeleteDocuments: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DocumentField.DefaultViewMode, '')
  defaultViewMode: SettingValue<string>;
}

class SiteConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.SiteField.EnableSiteRisk, false)
  enableSiteRisk: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.SiteField.EnableMissing, false)
  enableMissing: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.SiteField.EnableTimeliness, false)
  enableTimeliness: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.SiteField.EnableQuality, false)
  enableQuality: SettingValue<boolean>;

  @SettingsSubModule.value(GeneralFields.SiteField.RiskLevelHigh, 80)
  riskLevelHigh: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.RiskLevelMedium, 40)
  riskLevelMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.RiskLevelScoreDisplay, 1)
  riskLevelScoreDisplay: SettingValue<number>;

  @SettingsSubModule.value(GeneralFields.SiteField.MissingScorePrevalence, 40)
  missingScorePrevalence: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.MissingScoreMedium, 70)
  missingScoreMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.MissingScoreLow, 30)
  missingScoreLow: SettingValue<number>;

  @SettingsSubModule.value(GeneralFields.SiteField.TimelinessScorePrevalence, 60)
  timelinessScorePrevalence: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.TimelinessScoreMedium, 70)
  timelinessScoreMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.TimelinessScoreLow, 30)
  timelinessScoreLow: SettingValue<number>;

  @SettingsSubModule.value(GeneralFields.SiteField.QualityScorePrevalence, 50)
  qualityScorePrevalence: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.QualityScoreMedium, 70)
  qualityScoreMedium: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.SiteField.QualityScoreLow, 30)
  qualityScoreLow: SettingValue<number>;
}

class InboxConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.InboxField.EnableInbox, false) enableInbox: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.InboxField.EnableSsuInbox, false) enableSsuInbox: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.InboxField.AcceptEmailFrom, 1) acceptEmailFrom: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.InboxField.DomainNameWhiteList, '') domainNameWhiteList: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.InboxField.DomainAddress, '') domainAddress: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.InboxField.InboxEmail, '') inboxEmail: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.InboxField.SsuInboxEmail, '') ssuInboxEmail: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.InboxField.QueryResolutionInboxEmail, '')
  queryResolutionInboxEmail: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.InboxField.DocumentsAsFinal, 0) documentsAsFinal: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.InboxField.CodingNotRequired, false) codingNotRequired: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.InboxField.EnableCommunicationInbox, false)
  enableCommunicationInbox: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.InboxField.CommunicationEmail, '') communicationEmail: SettingValue<string>;
}
class OutboxConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.OutboxField.EnableCommunicationOutbox, false)
  enableCommunicationOutbox: SettingValue<boolean>;
}

class BrandingConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.BrandingField.ApplicationName, 'Trial Interactive')
  applicationName: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.BrandingField.SupportEmail, 'help@ti.ti') supportEmail: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.BrandingField.Logo, '')
  logo: SettingValue<string>;
}

class DtsIndex extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.DtsIndexField.DtsFileTypes, 'pdf') dtsFileTypes: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DtsIndexField.TAIndexLimit, 100) tAIndexLimit: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DtsIndexField.IndexingEngine, IndexingEngine.DTSearch + IndexingEngine.Solr)
  indexingEngine: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DtsIndexField.SearchEngine, SearchEngine.DTSearch)
  searchEngine: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.DtsIndexField.SyncStatus, 0) syncStatus: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.DtsIndexField.UpdatedDate, '') updatedDate: SettingValue<string>;
}

class EFaxConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.eFaxField.EnableEFax, false) enableEFax: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.eFaxField.BarcodeInstructions, '') barcodeInstructions: SettingValue<string>;
}

class DocumentViewerConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.DocumentViewerField.FlashViewerMode, 0) flashViewerMode: SettingValue<number>;
}

class SimplifiedUI extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.SimplifiedUiField.Instructions, '') instructions: SettingValue<string>;
}

class LinkedServersConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.LinkedServersField.ServerUrls, '') serverUrls: SettingValue<string>;
}

class TranslationConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.TranslationField.EnableMachineTranslation, false)
  enableMachineTranslation: SettingValue<boolean>;
  @SettingsSubModule.value(GeneralFields.TranslationField.AllowedTranslationLanguages, '')
  allowedTranslationLanguages: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.TranslationField.DefaultTranslateFromLanguage, '')
  defaultTranslateFromLanguage: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.TranslationField.DefaultTranslateToLanguage, '')
  defaultTranslateToLanguage: SettingValue<string>;
}

class FacetValuesLimitConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.Search.FacetValuesLimit, 100) facetValuesLimit: SettingValue<number>;
}

class RoomManagementConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.RoomManagementField.ClosedFolder, 0) closedFolder: SettingValue<number>;
}

class EventConfig extends SettingsSubModule {
  @SettingsSubModule.value(GeneralFields.EventConfigField.ReminderDays, '') reminderDays: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.DefaultReminderRecipientUsers, '')
  defaultReminderRecipientUsers: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.DefaultReminderRecipientGroups, '')
  defaultReminderRecipientGroups: SettingValue<string>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.ReminderForOverdue, 0)
  reminderForOverdue: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.ReminderForCompleted, 0)
  reminderForCompleted: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.SuggestPlaceholders, 0)
  suggestPlaceholders: SettingValue<number>;
  @SettingsSubModule.value(GeneralFields.EventConfigField.MatchPlaceholdersAutomatically, 0)
  matchPlaceholdersAutomatically: SettingValue<number>;
}

export class GeneralModule extends SettingsModule {
  @SettingsModule.value(IrbIntegrationConfig) irbIntegration: IrbIntegrationConfig;
  @SettingsModule.value(TaskConfig) task: TaskConfig;
  @SettingsModule.value(KeywordLookup) keywordLookup: KeywordLookup;
  @SettingsModule.value(RecNavConfig) recNav: RecNavConfig;
  @SettingsModule.value(WelcomeScreenConfig) welcomeScreen: WelcomeScreenConfig;
  @SettingsModule.value(AccessToAnyRoomConfig) accessToAnyRoom: AccessToAnyRoomConfig;
  @SettingsModule.value(ModuleConfig) module: ModuleConfig;
  @SettingsModule.value(IndexOutlineConfig) indexOutline: IndexOutlineConfig;
  @SettingsModule.value(GeneralConfig) general: GeneralConfig;
  @SettingsModule.value(Registration) registration: Registration;
  @SettingsModule.value(ExportSetting) exportSetting: ExportSetting;
  @SettingsModule.value(DocumentConfig) document: DocumentConfig;
  @SettingsModule.value(SiteConfig) site: SiteConfig;
  @SettingsModule.value(InboxConfig) inbox: InboxConfig;
  @SettingsModule.value(OutboxConfig) outbox: OutboxConfig;
  @SettingsModule.value(BrandingConfig) branding: BrandingConfig;
  @SettingsModule.value(DtsIndex) dtsIndex: DtsIndex;
  @SettingsModule.value(EFaxConfig) eFax: EFaxConfig;
  @SettingsModule.value(DocumentViewerConfig) documentViewer: DocumentViewerConfig;
  @SettingsModule.value(SimplifiedUI) simplifiedUI: SimplifiedUI;
  @SettingsModule.value(LinkedServersConfig) linkedServers: LinkedServersConfig;
  @SettingsModule.value(TranslationConfig) translation: TranslationConfig;
  @SettingsModule.value(RoomManagementConfig) roomManagement: RoomManagementConfig;
  @SettingsModule.value(FacetValuesLimitConfig) facetValuesLimitConfig: FacetValuesLimitConfig;
  @SettingsModule.value(EventConfig) eventManager: EventConfig;
}
